import { memo } from 'react';
import styled from 'styled-components';
import UIBadge from 'UIComponents/badge/UIBadge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InlineFlexLabel = styled.div.withConfig({
  displayName: "CampaignsPlatformSelectLabel__InlineFlexLabel",
  componentId: "sqmuzp-0"
})(["display:inline-flex;align-items:center;flex-direction:row;"]);
function CampaignsPlatformSelectLabel({
  associationSettings,
  objectType
}) {
  const {
    hasBetaBadge,
    hasNewBadge
  } = associationSettings[objectType].campaignsAssociations.metadata;
  const hasBadge = (hasBetaBadge === null || hasBetaBadge === void 0 ? void 0 : hasBetaBadge.value) || (hasNewBadge === null || hasNewBadge === void 0 ? void 0 : hasNewBadge.value);
  return /*#__PURE__*/_jsxs(InlineFlexLabel, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaignSelect.formEditorControlLabel"
    }), hasBadge && /*#__PURE__*/_jsx(UIBadge, {
      use: hasBetaBadge !== null && hasBetaBadge !== void 0 && hasBetaBadge.value ? 'beta' : 'new',
      className: "m-left-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `campaignSelect.${hasBetaBadge !== null && hasBetaBadge !== void 0 && hasBetaBadge.value ? 'beta' : 'new'}`
      })
    })]
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformSelectLabel);